import { useTranslation } from 'react-i18next';
import SectionTitle from '@/components/layout/section-title.tsx';
import Section from '@/components/layout/section.tsx';
import Block from '@/components/layout/block.tsx';

export default function Benefits() {
	const { t } = useTranslation();

	return (
		<Section className="flex flex-col flex-auto gap-6 max-sm:py-6">
			<SectionTitle className="text-neutral-600">{t('benefits.title')}</SectionTitle>

			<div className="flex flex-wrap gap-4">
				<Block
					title={t('benefits.quality.title')}
					titleClass="text-neutral-600"
					description={t('benefits.quality.description')}
					descriptionClass="text-neutral-500"
					icon={<img src="/icons/quality-icon.svg" alt={t('benefits.quality.title')} />}
					className="bg-neutral-200 border-neutral-200"
				/>

				<Block
					title={t('benefits.speed.title')}
					titleClass="text-[var(--primary)]"
					description={t('benefits.speed.description')}
					descriptionClass="text-[var(--primary)]/90"
					icon={<img src="/icons/speed-icon.svg" alt={t('benefits.speed.title')} />}
					className="bg-[var(--primary-light)] border-[var(--primary-light)]"
				/>

				<Block
					title={t('benefits.range.title')}
					titleClass="text-neutral-600"
					description={t('benefits.range.description')}
					descriptionClass="text-neutral-500"
					icon={<img src="/icons/range-icon.svg" alt={t('benefits.range.title')} />}
					className="bg-neutral-200 border-neutral-200"
				/>
			</div>
		</Section>
	);
}
